/** 素材 */
// 素材最大限制 打包版500G 
export const materialMaxSize_ispackage = 536870912000;
// DS-YUN云版客户最大上传素材限制改为 2G
export const materialMaxSize_dsyun = 2147483648;
// // 图片 100MB
// export const pictureMaxSize = 104857600;
// // 视频 500MB
// export const videoMaxSize = 524288000;
// // 音乐 50M
// export const musicMaxSize = 52428800;
// // 互动应用 2G
// export const appZipMaxSize = 2147483648;
// // wold 50M
// export const wordMaxSize = 52428800;
// // ppt 50M
// export const pptMaxSize = 52428800;
// // excel 50M
// export const excelMaxSize = 52428800;
// // pdf 50M
// export const pdfMaxSize = 52428800;
// // apk 500M
// export const apkMaxSize = 524288000;

// 素材后缀
export const materialExtFilters = [
    ".jpg", ".png", ".jpeg", ".gif", ".bmp",
    ".avi", ".mpeg", ".wmv", ".mpg", ".ra", 
    ".rm", ".ram", ".rmvb", ".dat", ".mov",
    ".asf", ".mtv", ".mkv", ".3gp", ".mp4", 
    ".amv", ".dmv", ".divx", ".ts", ".flv",
    ".mp3", ".doc", ".docx", ".xls", ".xlsx",
    ".ppt", ".pptx", ".pdf", ".rom", ".img",
    ".zip", ".bin", ".inf"
];

// 图片后缀
export const picExtFilters = [".jpg", ".png", ".jpeg", ".gif", ".bmp"]
// 视频后缀
export const videoExtFilters = [".avi", ".mpeg", ".wmv", ".mpg", ".ra", ".rm", ".ram", ".rmvb", ".dat", ".mov", ".asf",
".mtv", ".mkv", ".3gp", ".mp4", ".amv", ".dmv", ".divx", ".ts", ".flv"];
// 音乐后缀
export const musicExtFilters = [".mp3"];
// word后缀
export const wordExtFilters = [".doc", ".docx"];
// excel后缀
export const excelExtFilters = [".xls", ".xlsx"];
// ppt后缀
export const pptExtFilters = [".ppt", ".pptx"];
// 互动应用后缀
export const appZipExtFilters = [".zip"];
// pdf后缀
export const pdfExtFilters = [".pdf"];
// apk后缀
export const apkExtFilters = [".apk"];
// 终端升级
export const sysExtFilters = [".rom", ".img", ".zip", ".bin", ".inf"];
// 升级文件
export const upgradeFileExtFilters = [".rom", ".img", ".zip", ".bin", ".inf", ".apk"];

/** 内容正则 */
export const contentRsg = /^(([\u4e00-\u9fa5_a-zA-Z0-9!@#$^&*().]{1,})|([\u4e00-\u9fa5_a-zA-Z0-9!@#$^&*().]{1,}[\u4e00-\u9fa5_a-zA-Z0-9!@#$^&*(). ]*[\u4e00-\u9fa5_a-zA-Z0-9!@#$^&*().]{1,}))$/

/** 素材模块内容正则 文件名不能包含以下任何字符: \ / : * ? " < > | */
export const materialConRsg = '[\\\\/:*?\"<>|]';

/** 字母和数字 */
export const letterAndNum = /^[a-zA-Z0-9]+$/

/** 手机号正则 */
export const phoneRsg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/

/** 银行卡号正则*/
export const bankRsg = /^([1-9]{1})(\d{14}|\d{18})$/

/** 邮箱正则*/
export const emailRsg=/^(\w+([-.][A-Za-z0-9]+)*){3,18}@\w+([-.][A-Za-z0-9]+)*\.\w+([-.][A-Za-z0-9]+)*$/

/** 版本号正则 x.x.x.x 数字 */
export const versionRsg=/^\d+(\.\d+){3}$/


// WEBPACK FOOTER //
// ./src/utils/common/constants.js